/// <amd-module name="Wit/BacklogsHub/BacklogSettings/Components/AutomationSettingsView/AutomationSettingsInterfaces" />
import { IObservableValue } from "VSS/Core/Observable";

export interface IObservableAutomationRulesStatesViewData {
    isActiveEnabled: IObservableValue<boolean>;
    isCompletedEnabled: IObservableValue<boolean>;
    isResolvedEnabled: IObservableValue<boolean>;
}

export interface IOriginalAutomationRulesSettingData {
    isActiveEnabled: boolean;
    isCompletedEnabled: boolean;
    isResolvedEnabled: boolean;
}

export interface IAutomationRulesRequestModel {
    backlogLevelName: string;
    rulesStates: { [key: string]: boolean };
}
